<form autocomplete="off" [formGroup]="affiliateOptionsForm" (ngSubmit)="submitForm()">
  <div class="modal-body">
    <div class="form-group">
      <label for="affiliateOptionsInput">{{ 'LOGIN_PAGE.CLIENT_NUMBER' | translate }}</label>

      <input
        class="form-control"
        typeaheadOptionField="DisplayValue"
        formControlName="selected"
        id="affiliateOptionsInput"
        aria-autocomplete="both"
        aria-haspopup="false"
        autocapitalize="off"
        autocomplete="off"
        autocorrect="off"
        role="combobox"
        spellcheck="false"
        aria-label="Search"
        [placeholder]="'LOGIN_PAGE.CLIENT_NUMBER' | translate"
        [typeahead]="affiliateOptions$ | async"
        [typeaheadItemTemplate]="affiliateOption"
        [typeaheadScrollable]="true"
        [typeaheadIsFirstItemActive]="false"
        [typeaheadOptionsInScrollableView]="10"
        (typeaheadNoResults)="handleNoResults($event)"
        (typeaheadOnSelect)="handleSelect($event)"
        (typeaheadOnBlur)="handleBlur()"
      />

      <small *ngIf="noResults" class="form-text text-danger">{{ 'LOGIN_PAGE.NO_MATCH' | translate }}</small>
    </div>

    <p class="text-info small">{{ 'LOGIN_PAGE.CLIENT_NUMBER_WARNING' | translate }}</p>

    <div class="d-flex justify-content-end">
      <button type="button" class="btn btn-default mr-2" (click)="onCloseModal()">
        {{ 'LOGIN_PAGE.CANCEL' | translate }}
      </button>

      <button type="submit"
              class="btn btn-primary"
              [disabled]="!affiliateSelectedOption || affiliateOptionsForm.untouched || loading">
        {{ 'LOGIN_PAGE.PROCEED' | translate }}
      </button>
    </div>
  </div>
</form>

<!-- #hotelNameItem template -->
<ng-template #affiliateOption let-item="item">
  {{ item.DisplayValue }}
</ng-template>
